/* globals google */

import $ from 'jquery';
import GoogleMapsLoader from 'google-maps';

/**
 * @var map google.map
 */

class GoogleMap {
    constructor (selector) {
        GoogleMapsLoader.KEY    = 'AIzaSyDal5GDiOaoF8ZBpNpoIaNSc0uNwsr1zm4';
        GoogleMapsLoader.REGION = 'GB';

        // Only run if google is available
        // if (typeof google !== 'undefined') {
        this.$mapContainers = $(selector);

        if (typeof GoogleMapsLoader === 'object') {
            this.init();
        }
    }

    static addMarker ($marker, map) {
        const latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

        // Create marker
        const marker = new google.maps.Marker({
            'position' : latlng,
            'map'      : map
        });

        // Add to array
        map.markers.push(marker);

        // If marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // Create info window
            const infowindow = new google.maps.InfoWindow({
                content : $marker.html()
            });

            // Show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', () => {
                infowindow.open(map, marker);
            });
        }
    }

    static centerMap (map) {
        const bounds = new google.maps.LatLngBounds();

        // Loop through all markers and create bounds
        $.each(map.markers, (i, marker) => {
            const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            bounds.extend(latlng);
        });

        // Only 1 marker?
        if (map.markers.length === 1) {
            // Set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(16);
        } else {
            // Fit to bounds
            map.fitBounds(bounds);
        }
    }

    newMap ($el) {
        const $markers = $el.find('.js-marker');
        let map        = null;

        GoogleMapsLoader.load((google) => {
            // Create map
            map = new google.maps.Map($el[0], this.mapOptions);

            // Create the custom style
            const customMapType = new google.maps.StyledMapType(this.customStyleConfig, this.styledMapOptions);

            // Apply the custom style
            map.mapTypes.set(this.customMapStyleId, customMapType);

            // Init Markers
            map.markers = [];

            for (let i = 0; i < $markers.length; i++) {
                const $this = $($markers[i]);
                // Create map
                GoogleMap.addMarker($this, map);
            }

            // Center the map
            GoogleMap.centerMap(map);
        });

        // return
        return map;
    }

    init () {
        const $maps = this.$mapContainers;

        for (let i = 0; i < $maps.length; i++) {
            const $this = $($maps[i]);

            // Create map
            this.newMap($this);
        }

        // Scroll disabling until clicked
        $maps.on('click', function () {
            $(this).find('.gm-style').css('pointer-events', 'auto');
        });
    }
}
export default GoogleMap;
